export default "__VITE_ASSET__BYrNh9wI__";